import styled from '@emotion/styled'
import { V2L2LargeModalRoot } from "../V2L2ModalRoot"
import { V2L2ModalTitlebar, V2L1ModalDismissButton } from "../V2ModalTitlebar"
import { ReactNode, useEffect, useRef } from 'react'
import { V2L1LoadingIndicator } from '../../Indicator/V2L1LoadingIndicator'

const ModalContent = styled.div(({theme}) => ({
	flex: 1,
	overflowY: 'scroll',
	backgroundColor: theme.colors.logBg,
	...theme.fonts.monoLight,
	fontSize: `${12/16}rem`,
	letterSpacing: `${1/32}rem`,
	lineHeight: `${18/12}em`,
	color: theme.colors.white,
	padding: '1rem',
	'svg': {
		fontSize: '1rem',
	},
}))

interface LineProps {
	error: boolean
}

const Line = styled.div<LineProps>(({theme, error}) => ({
	color: error ? theme.colors.stopRed : 'inherit',
	...(error ? theme.fonts.mono : {}),
}))

const ActivityRow = styled.div({
	marginTop: '.5rem',
	display: 'flex',
	flexDirection: 'row',
	alignItems: 'center',
	columnGap: '.75rem',
})

interface V2L3LogModalProps {
	entries: string[]
	actions?: ReactNode
	working: boolean
	onDismissClick?: React.MouseEventHandler<HTMLButtonElement>
}

export const V2L3LogModal = ({entries, actions, working, onDismissClick}: V2L3LogModalProps) => {
	const contentRef = useRef<HTMLDivElement|null>(null)
	useEffect(() => {
		if(contentRef.current) {
			contentRef.current.scrollTop = contentRef.current.scrollHeight
		}
	}, [entries])
	return (
		<V2L2LargeModalRoot>
			<V2L2ModalTitlebar
				title="Log"
				buttons={<V2L1ModalDismissButton onClick={onDismissClick} />}
			/>
			<ModalContent ref={contentRef}>
				{entries.map((line, idx) => <Line key={idx} error={line.includes('Error')}>{line}</Line>)}
				<ActivityRow>
					{actions}
					<V2L1LoadingIndicator
						// keep the vertical padding at the bottom of the log
						// wether this is visible or not
						visibility={working ? 'initial' : 'hidden'}
					/>
				</ActivityRow>
			</ModalContent>
		</V2L2LargeModalRoot>
	)
}
